<template>
	<table class="table table-bordered m-table">
		<thead>
			<tr>
				<th v-if="type=='da'" :colspan="currentGame == 1 ? 2 : 2">{{title}}</th>
				<th v-else-if="type=='4d'" colspan="3">{{title}}</th>
				<th v-else :colspan="currentGame == 1 ? 4 : 5">{{title}}</th>
				<th colspan="1" class="toolBtnContainer">
					<button @click="showTangCommission()" type="button" class="btn btn-sm btn-brand m-btn m-btn--custom addComBtn">Tăng</button>
				</th>
			</tr>
			<tr>
				<th>Số</th>
				<th v-for="h in header[currentGame][type]">{{h.value}}</th>
				<th></th>
			</tr>
		</thead>
		<tbody>
			<commission-editor
				v-if="formVisible"
				:type="type"
				:header="header[currentGame][type]"
				:dataKey="dataKey"
				v-on:number-add="onNumberAddClick"
				v-on:number-cancel="onCancelCommission"
			></commission-editor>
			<tr v-if="!comms">
				<td v-if="type=='da'" :colspan="currentGame == 1 ? 2 : 2">Không có dữ liệu</td>
				<td v-else :colspan="currentGame == 1 ? 4 : 5">Không có dữ liệu</td>
			</tr>
			<template v-else-if="type!='da' || (type=='da' && currentGame!=2)" v-for="(obj,idx) in comms">
				<commission-editor
					v-if="editable[idx]"
					:index="idx"
					:type="type"
					:commission="obj"
					:header="header[currentGame][type]"
					:dataKey="dataKey"
					v-on:number-add="onNumberAddClick"
					v-on:number-cancel="onCancelCommission"
				></commission-editor>
				<tr v-if="!editable[idx]" :class="'com_parent '+(idx %2 == 1 ? 'even-bg' : '')">
					<td rowspan="2" class="commission-number">{{obj.number}}</td>
					<td v-for="h in header[currentGame][type]">
						<div v-if="obj.comm[h.id]">
							{{dataKey.data == 'limit' ? obj.comm[h.id][0][dataKey.parent] : parseFloat(obj.comm[h.id][0][dataKey.parent]).toFixed(3)}}
							<span class="dropdown" v-if="dataKey.data != 'limit'">
	                            <div class="btn m-btn m-btn--hover-brand m-btn--icon m-btn--icon-only m-btn--pill" data-toggle="dropdown" aria-expanded="true">
	                              <i class="la la-info-circle"></i>
	                            </div>
	                            <div class="dropdown-menu dropdown-menu-right">
	                            	<div v-if="obj.comm[h.id][0].created_by == user.code && user.code != obj.comm[h.id][0].code" class="dropdown-item header"><span class="class_name">{{ obj.comm[h.id][0].code.toUpperCase() }}</span></div>
	                                <div v-for="(he, cls) in obj.comm[h.id][0].commission" class="dropdown-item"><span class="class_name">{{"Hệ "+String.fromCharCode(-1*cls+64).toUpperCase()}}</span><span class="class_value">{{parseFloat((he+obj.comm[h.id][0][dataKey.parent]).toFixed(3))}}</span></div>
	                            </div>
	                        </span>
						</div>
					</td>
					<td rowspan="2">
						<button type="button" @click="onEditCommission(idx)" class="btn btn-sm btn-success btn-brand m-btn m-btn--custom addComBtn">Sửa</button>
					</td>
				</tr>
				<tr v-if="!editable[idx]" :class="'com_child '+(idx %2 == 1 ? 'even-bg' : '')">
					<td v-for="h in header[currentGame][type]">
						<div v-if="obj.comm[h.id]">
							{{dataKey.data == 'limit' ? obj.comm[h.id][0][dataKey.child] : parseFloat(obj.comm[h.id][0][dataKey.child]).toFixed(3)}}
							<span class="dropdown" v-if="dataKey.data != 'limit'">
	                            <div class="btn m-btn m-btn--hover-brand m-btn--icon m-btn--icon-only m-btn--pill" data-toggle="dropdown" aria-expanded="true">
	                              <i class="la la-info-circle"></i>
	                            </div>
	                            <div class="dropdown-menu dropdown-menu-right">
	                            	<div v-if="obj.comm[h.id][0].created_by == user.code && user.code != obj.comm[h.id][0].code" class="dropdown-item header"><span class="class_name">{{ obj.comm[h.id][0].code.toUpperCase() }}</span></div>
	                                <div v-for="(he, cls) in obj.comm[h.id][0].commission" class="dropdown-item"><span class="class_name">{{"Hệ "+String.fromCharCode(-1*cls+64).toUpperCase()}}</span><span class="class_value">{{parseFloat((he+obj.comm[h.id][0][dataKey.child]).toFixed(3))}}</span></div>
	                            </div>
	                        </span>
						</div>
					</td>
				</tr>
			</template>
			<template v-else v-for="(obj,idx) in comms">
				<commission-editor
					v-if="editable[idx]"
					:index="idx"
					:type="type"
					:header="header[currentGame][type]"
					:commission="obj"
					v-on:number-add="onNumberAddClick"
					v-on:number-cancel="onCancelCommission"
				></commission-editor>
				<tr v-if="!editable[idx]" :class="'com_parent '+(idx %2 == 1 ? 'even-bg' : '')">
					<td rowspan="2" class="commission-number">{{obj.number}}</td>
					<td v-if="obj.comm['14']">
						<div :title="channelToName(obj.comm['14'][0].channel)">
							{{dataKey.data == 'limit' ? obj.comm['14'][0][dataKey.parent] : parseFloat(obj.comm['14'][0][dataKey.parent]).toFixed(3)}}
							<span class="dropdown" v-if="dataKey.data != 'limit'">
	                            <div class="btn m-btn m-btn--hover-brand m-btn--icon m-btn--icon-only m-btn--pill" data-toggle="dropdown" aria-expanded="true">
	                              <i class="la la-info-circle"></i>
	                            </div>
	                            <div class="dropdown-menu dropdown-menu-right">
	                            	<div v-if="obj.comm['14'][0].created_by == user.code && user.code != obj.comm['14'][0].code" class="dropdown-item header"><span class="class_name">{{ obj.comm['14'][0].code.toUpperCase() }}</span></div>
	                                <div v-for="(he, cls) in obj.comm['14'][0].commission" class="dropdown-item"><span class="class_name">{{"Hệ "+String.fromCharCode(-1*cls+64).toUpperCase()}}</span><span class="class_value">{{parseFloat((he+obj.comm['14'][0][dataKey.parent]).toFixed(3))}}</span></div>
	                            </div>
	                        </span>
						</div>
					</td>
					<td v-if="obj.comm['17']">
						<div :title="channelToName(obj.comm['17'][0].channel)">
							{{dataKey.data == 'limit' ? obj.comm['17'][0][dataKey.parent] : parseFloat(obj.comm['17'][0][dataKey.parent]).toFixed(3)}}
							<span class="dropdown" v-if="dataKey.data != 'limit'">
	                            <div class="btn m-btn m-btn--hover-brand m-btn--icon m-btn--icon-only m-btn--pill" data-toggle="dropdown" aria-expanded="true">
	                              <i class="la la-info-circle"></i>
	                            </div>
	                            <div class="dropdown-menu dropdown-menu-right">
	                            	<div v-if="obj.comm['17'][0].created_by == user.code && user.code != obj.comm['17'][0].code" class="dropdown-item header"><span class="class_name">{{ obj.comm['17'][0].code.toUpperCase() }}</span></div>
	                                <div v-for="(he, cls) in obj.comm['17'][0].commission" class="dropdown-item"><span class="class_name">{{"Hệ "+String.fromCharCode(-1*cls+64).toUpperCase()}}</span><span class="class_value">{{parseFloat((he+obj.comm['17'][0][dataKey.parent]).toFixed(3))}}</span></div>
	                            </div>
	                        </span>
						</div>
					</td>
					<td rowspan="2">
						<button type="button" @click="onEditCommission(idx)" class="btn btn-sm btn-success btn-brand m-btn m-btn--custom addComBtn">Sửa</button>
					</td>
				</tr>
				<tr v-if="!editable[idx]" :class="'com_child '+(idx %2 == 1 ? 'even-bg' : '')">
					<td v-if="obj.comm['14']">
						<div :title="channelToName(obj.comm['14'][0].channel)">
							{{dataKey.data == 'limit' ? obj.comm['14'][0][dataKey.child] : parseFloat(obj.comm['14'][0][dataKey.child]).toFixed(3)}}
							<span class="dropdown" v-if="dataKey.data != 'limit'">
	                            <div class="btn m-btn m-btn--hover-brand m-btn--icon m-btn--icon-only m-btn--pill" data-toggle="dropdown" aria-expanded="true">
	                              <i class="la la-info-circle"></i>
	                            </div>
	                            <div class="dropdown-menu dropdown-menu-right">
	                            	<div v-if="obj.comm['14'][0].created_by == user.code && user.code != obj.comm['14'][0].code" class="dropdown-item header"><span class="class_name">{{ obj.comm['14'][0].code.toUpperCase() }}</span></div>
	                                <div v-for="(he, cls) in obj.comm['14'][0].commission" class="dropdown-item"><span class="class_name">{{"Hệ "+String.fromCharCode(-1*cls+64).toUpperCase()}}</span><span class="class_value">{{parseFloat((he+obj.comm['14'][0][dataKey.child]).toFixed(3))}}</span></div>
	                            </div>
	                        </span>
						</div>
					</td>
					<td v-if="obj.comm['17']">
						<div :title="channelToName(obj.comm['17'][0].channel)">
							{{dataKey.data == 'limit' ? obj.comm['17'][0][dataKey.child] : parseFloat(obj.comm['17'][0][dataKey.child]).toFixed(3)}}
							<span class="dropdown" v-if="dataKey.data != 'limit'">
	                            <div class="btn m-btn m-btn--hover-brand m-btn--icon m-btn--icon-only m-btn--pill" data-toggle="dropdown" aria-expanded="true">
	                              <i class="la la-info-circle"></i>
	                            </div>
	                            <div class="dropdown-menu dropdown-menu-right">
	                            	<div v-if="obj.comm['17'][0].created_by == user.code && user.code != obj.comm['17'][0].code" class="dropdown-item header"><span class="class_name">{{ obj.comm['17'][0].code.toUpperCase() }}</span></div>
	                                <div v-for="(he, cls) in obj.comm['17'][0].commission" class="dropdown-item"><span class="class_name">{{"Hệ "+String.fromCharCode(-1*cls+64).toUpperCase()}}</span><span class="class_value">{{parseFloat((he+obj.comm['17'][0][dataKey.child]).toFixed(3))}}</span></div>
	                            </div>
	                        </span>
						</div>
					</td>
				</tr>
			</template>
		</tbody>
	</table>
</template>

<script>
	import { mapGetters } from 'vuex';
	import NumberEditor from './NumberEditor';

	export default {
		props: ['currentGame', 'title', 'comms', 'type', 'dataKey'],

		data(){
			let vm = this;

	        return {
	        	"originComs": [],
	        	"formVisible": false,
	        	"editable": [],
	        	"header": { 
	        		"1": {
	        			"2d": [{"id":1, "value": "Đầu"},{"id":2, "value": "Đuôi"},{"id":4, "value": "27 Lô"}],
	        			"3d": [{"id":6, "value": "Đầu"},{"id":7, "value": "Đầu"},{"id":9, "value": "23 Lô"}],
	        			"4d": [{"id":11, "value": "Đuôi"},{"id":12, "value": "20 Lô"}],
	        			"da": [{"id":14, "value": "Đá thẳng"}]
	        		}, 
	        		"2": {
	        			"2d": [{"id":1, "value": "Đầu"},{"id":2, "value": "Đuôi"},{"id":3, "value": "7 Lô"},{"id":5, "value": "18 Lô"}],
	        			"3d": [{"id":6, "value": "Đầu"},{"id":7, "value": "Đuôi"},{"id":8, "value": "7 Lô"},{"id":10, "value": "17 Lô"}],
	        			"4d": [{"id":11, "value": "Đuôi"},{"id":13, "value": "16 Lô"}],
	        			// "da": [{"id":14, "value": "Đá thẳng"},{"id":17, "value": "Đá xiên"}]
	        			"da": [{"id":14, "value": "Đá thẳng"}]
	        		}, 
	        		"4": {
	        			"2d": [{"id":1, "value": "Đầu"},{"id":2, "value": "Đuôi"},{"id":3, "value": "7 Lô"},{"id":5, "value": "18 Lô"}],
	        			"3d": [{"id":6, "value": "Đầu"},{"id":7, "value": "Đuôi"},{"id":8, "value": "7 Lô"},{"id":10, "value": "17 Lô"}],
	        			"4d": [{"id":11, "value": "Đuôi"},{"id":13, "value": "16 Lô"}],
	        			"da": [{"id":14, "value": "Đá thẳng"}]
	        		},
				}
	        }
	    },

	    components: {
        	'commission-editor': NumberEditor,
        },

        computed: {
			...mapGetters({
				user: 'user',
		  		gameInfo: 'gameInfo'
			})
		},

		methods: {
			showTangCommission: function(){
				this.formVisible = true;
			},
			hideNumberEditor: function(idx){
				if(idx == -1) this.formVisible = false;
				else{
					let arr = [...this.editable];
					arr[idx] = false;
					this.editable = arr;
				}
			},
			onNumberAddClick: function({data, index}){
				let vm = this;
				this.$emit("number-add-click", {data: data, callback: () => {vm.hideNumberEditor(index);}});
			},
			onCancelCommission: function(idx){
				if(idx == -1) this.formVisible = false;
				else{
					let arr = [...this.editable];
					arr[idx] = false;
					this.editable = arr;
				}
			},
			onEditCommission: function(idx){
				let arr = [...this.editable];
				arr[idx] = true;

				this.editable = arr;
			},
			channelToName: function(channel){
				let vm = this;
				if(channel.indexOf(".") >= 0){
					let chns = channel.split(".").map((cns) => { return vm.gameInfo.channels[parseInt(cns)].alias; });
        			return chns.join(", ");
				}

				return vm.gameInfo.channels[parseInt(channel)].alias;
			}
		}
	}
</script>

<style>
	.commission-number{
	    color: #747474;
	    font-size: 20px;
	    font-weight: 400;
	}
	.even-bg{
		background-color: #f4f5f8;
	}
	.toolBtnContainer{
		text-align: right;
	}
	.btn.m-btn--custom.btn-sm.addComBtn{
		margin-right: 5px;
		padding: 0.1rem 0.5rem;
	}
	.class_name{
		float: left;
	}
	.class_value{
		float: right;
	}
	.table{
		text-align: center;
	}
	.table th,
	.table td{
		padding: 5px;
		vertical-align: inherit;
	}
	.table td .dropdown{
		float: right;
	}
	.table td .dropdown .m-btn--icon.m-btn--icon-only{
		width: 15px;
		height: 15px;
	}
	.m-portlet-incr-com tr.com_parent{
		color: red;
	}
	.m-portlet-incr-com tr.com_child{
		color: blue;
	}
	.m-portlet-incr-com .table th,
	.m-portlet-incr-com .table td{
		padding: 2px 0;
		vertical-align: inherit;
	}
	.m-portlet-incr-com .table td .dropdown{
		float: right;
	}
	.m-portlet-incr-com .table td .dropdown .m-btn--icon.m-btn--icon-only{
		width: 15px;
		height: 15px;
	}
	.m-portlet-incr-com .class_value{
		float: right;
	}
	.m-portlet-incr-com .dropdown-item.header{
		border-bottom: 1px dashed #dbdbdb;
	    text-align: center;
	}
</style>